import React from 'react'

import styled from 'styled-components'

import { MoveEntityButton } from './MoveEntityButton'
import { DeleteEntityButton } from './DeleteEntityButton'

type EntityTypes =
    | WellDto
    | InterventionsDto
    | SectionDto
    | RigTableDto
    | RunDto
    | CementedPlugDto
    | TubularTypeDto
    | TubularRestrictedPipeMovementsDto
    | TubularRestrictedConnectionDto
    | TubularRestrictedRopDto

interface ActionsColumnButtonsProps {
    entity: EntityTypes
    possibleParents: EntityTypes[]
    parentName: string
    entityName: string
    moveEntityToAnotherParent: (entity: EntityTypes, selectedParent: number) => void
    handleDelete: (entity: EntityTypes) => void
}

export const ActionsColumnButtons = ({
    entity,
    possibleParents,
    parentName,
    entityName,
    moveEntityToAnotherParent,
    handleDelete
}: ActionsColumnButtonsProps) => {
    return (
        <ActionsColumnButtonsContainer>
            <MoveEntityButton
                entity={entity}
                possibleParents={possibleParents}
                parentName={parentName}
                entityName={entityName}
                moveEntityToAnotherParent={moveEntityToAnotherParent}
            />
            <DeleteEntityButton entity={entity} entityName={entityName} handleDelete={handleDelete} />
        </ActionsColumnButtonsContainer>
    )
}

const ActionsColumnButtonsContainer = styled.div`
    display: flex;
    justify-content: right;
    gap: 12px;
`
